import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const ViewBlock = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
};

const TechTemplate = ({ children, tech, error, loading }) => {
  //에러 발생시
  if (error) {
    if (error.response && error.response.status === 404) {
      return <ViewBlock>존재하지 않는 데이터입니다.</ViewBlock>;
    }
    return <ViewBlock>오류 발생</ViewBlock>;
  }

  //로딩 중이거나 아직 포스트가 없을때
  if (loading || !tech) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <Box>{children}</Box>;
};

export default TechTemplate;
